module.exports = __webpack_public_path__ + "img/mainImg.203bc8f8.png";